import { createContext } from "react";

const Auth = createContext({
  token: localStorage.getItem("token"),
  logout: () => {},
});

export default Auth;
